import React, {PureComponent, CSSProperties, ComponentClass} from 'react'
import {inject, observer} from 'mobx-react'
import {Route, Redirect, Switch} from 'react-router-dom'
import cxs from 'cxs/component'
import Store from 'Store'
import {User} from 'modules/Users/Model'
import Theme, {mediaQueries} from 'Theme'
import DashboardTicket from 'modules/DashboardTicket'
import Articles from 'modules/Articles'
import Families from 'modules/Families'
import SettingsInvoice from 'modules/SettingsInvoice'
import Customers from 'modules/Customers'
import Users from 'modules/Users'
import Branches from 'modules/Branches'
import Reports from 'modules/Reports'
import Taxes from 'modules/Taxes'
import {TitleBar, NavBar} from 'components'
import {Scroll} from 'elements'
import NavBarConfiguracion from 'components/NavBarConfiguracion'
import NavBarDatosEmpresa from 'components/NavBarDatosEmpresa'
import NavBarOperaciones from 'components/NavBarOperaciones'
import BusinessUnits from 'modules/BusinessUnits'
import OperationLines from 'modules/OperationLines'
import PassengerCategories from 'modules/PassengerCategories'
import StretchesRoutes from 'modules/Stretches'
import TicketCashDesk from 'modules/Reports'
import TicketGratis from '../modules/Reports'
import Devices from '../modules/Devices'

interface Props {
  store?: Store
}

@inject('store')
@observer
class Main extends PureComponent<Props, object> {
  render() {
    const {isDesktop} = this.props.store!.UI
    const routes = [].concat.apply(
      [],
      sections(this.props.store!.users.user).map(section => section.links)
    )
    const routesMenu = [].concat.apply([],
      sectionsNavBar())
    const {menuSelected} = this.props.store!.UI
    const {menuSelectedConfiguracion} = this.props.store!.UI

    /*console.log('routesMenu', routesMenu)
    console.log('routes', routes)*/

    return (
      <Wrapper>
        <TitleBar/>
        <Content>
          <Scroll>
            <Switch>
              /* NEXT: Enable dashboard*/
              <Route exact path="/dashboardticket" component={DashboardTicket}/>
              {/*<Route exact path="/" render={() => <Redirect to="tickets"/>}/>*/}
              <Route exact path="/" render={() => <Redirect to="dashboardticket"/>}/>
              {routes.map((route, index) => (
                <Route
                  key={index}
                  path={route.path}
                  component={route.component}
                />
              ))}
              {routesMenu.map((route, index) => (
                <Route
                  key={index}
                  path={`/${route.name}`}
                  render={() => <Redirect to={route.redirect}/>}/>
              ))}

            </Switch>
          </Scroll>
        </Content>
        {/*{!isDesktop && <NavBar/>}*/}
      </Wrapper>
    )
  }
}

export default Main

const Wrapper = cxs('div')({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  [mediaQueries.mobile]: {
    height: '95%'
  },

  /*[mediaQueries.desktop]: {*/
  maxHeight: '100%',
  margin: `0 auto auto auto`,
  borderColor: Theme.color.hairline,
  borderWidth: `0 ${Theme.size.hairline}`,
  borderStyle: 'solid',
  /*maxWidth: Theme.common.size.maxWidth + 'px',*/
  width: '100%',
  /*paddingRight: '15px',
  paddingLeft: '15px',*/
  /*marginRight: 'auto',*/
  /*marginLeft: 'auto',*/
  /*'@media (min-width: 576px)': {
    maxWidth: '576px'
  },*/
  '@media (min-width: 720px)': {
    maxWidth: '720px'
  },
  '@media (min-width: 992px)': {
    maxWidth: '992px'
  },
  '@media (min-width: 1200px)': {
    maxWidth: '1140px'
  }
  /*} as CSSProperties*/
} as CSSProperties)

const Content = cxs('div')({
  flex: 1,
  display: 'flex',
  position: 'relative',
  /*[mediaQueries.desktop]: {*/
  /*flex: 'auto',*/
  minHeight: '100px'
  /*} as CSSProperties*/
} as CSSProperties)

export const sectionsNavBar = () => {
  return [
    {
      name: 'configuracion',
      redirect: '/users'
    },
    {
      name: 'operaciones',
      redirect: '/customers'
    },
    {
      name: 'reportes',
      redirect: '/sales'
    }
  ]
}

export const sections = (user: User) => {
  return [
    /*{
      name: 'wharehouse',
      links: [
        {
          name: 'articles',
          path: '/articles',
          component: Articles
        },
        {
          name: 'families',
          path: '/families',
          component: Families
        }
      ]
    },*/
    /*{
      name: 'sales',
      links: [
        {
          name: 'customers',
          path: '/customers',
          component: Customers
        }
      ]
    },*/
    /*{
      name: 'reports',
      links: [
        {
          name: 'sales',
          path: '/sales',
          component: Reports
        },
        {
          name: 'cashDesk',
          path: '/cashdesk',
          component: Reports
        }
      ]
    },*/
    {
      name: 'wharehouse',
      links: [
        {
          name: 'operationlines',
          path: '/operationlines',
          component: OperationLines
        },
        {
          name: 'stretches',
          path: '/stretches',
          component: StretchesRoutes
        }
      ]
    },
    {
      name: user.isAdministrator ? 'settings' : '',
      links: [
        {
          name: 'businessunits',
          path: '/businessunits',
          component: BusinessUnits
        },
        {
          name: 'users',
          path: '/users',
          component: Users
        },
        {
          name: 'passengercategories',
          path: '/passengercategories',
          component: PassengerCategories
        },
        {
          name: 'devices',
          path: '/devices',
          component: Devices
        },
        {
          name: 'taxes',
          path: '/taxes',
          component: Taxes
        },
        /*user.isRetail
          ? {
            name: 'branches',
            path: '/branches',
            component: Branches
          }
          : undefined,*/
        /* {
           name: 'invoice',
           path: '/invoice',
           component: SettingsInvoice
         },*/

        /*{
          name: 'operationlines',
          path: '/operationlines',
          component: OperationLines
        },*/
        /* {
           name: 'stretches',
           path: '/stretches',
           component: StretchesRoutes
         }*/
      ]
    },
    {
      name: 'reports',
      links: [
        {
          name: 'tickets',
          path: '/tickets',
          component: Reports
        },
        {
          name: 'Cierre de caja',
          path: '/ticketCashDesk',
          component: TicketCashDesk
        },
        {
          name: 'dashboard',
          path: '/dashboardticket',
          component: DashboardTicket
        },
        {
          name: 'ticket gratis',
          path: '/ticketGratis',
          component: TicketGratis
        },
        {
          name: 'ticket cancelados',
          path: '/ticketCanceled',
          component: TicketGratis
        },
      ]
    }
  ]
    .filter(section => section.name)
    .map(section => ({
      ...section,
      links: section.links.filter(link => link) as {
        name: string
        path: string
        component: ComponentClass
      }[]
    }))
}
// .map(section => ({
//   ...section,
//   links: section.links.map(link => ({
//     ...link,
//     path: '/' + section.name + link.path
//   }))
// }))



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/scenes/Main.tsx